// The System Project (Task Board) guide (64_TaskBoard.jsx · ModuleHelp, Max 01/11).
const en = {
  boardsT: 'Whose board',
  boardsB: 'My tasks are yours. Beside it come the boards other people shared with you, and Shared with me lists the tasks shared one by one.',
  viewsT: 'Three views',
  viewsB: 'Board shows the columns, Timeline lays the tasks out by date, and My day sums up what you did today.',
  searchT: 'Search and filter',
  searchB: 'Search the tasks on this board, show only the urgent ones, and choose how each column is ordered: your own order, by due date or by priority.',
  columnsT: 'The columns',
  columnsB: 'Backlog, To do, In progress, Review and Done. Drag a card to another column as the work moves, and click a card to open it.',
  newT: 'New task',
  newB: 'Create a task with a description, files, a due date and the people on it. You see this button only if you may create tasks.',
  shareT: 'Share my board',
  shareB: 'Choose who can see your board. People you share with can open it from their own board list.',
};
const ko = {
  boardsT: '누구의 보드',
  boardsB: '내 업무는 내 보드입니다. 옆에는 다른 사람이 나와 공유한 보드가, 나와 공유됨에는 건별로 공유된 업무가 나옵니다.',
  viewsT: '세 가지 보기',
  viewsB: '보드는 열별 보기, 타임라인은 날짜별 배치, 오늘 한 일은 오늘 한 업무 요약입니다.',
  searchT: '검색과 필터',
  searchB: '이 보드의 업무를 검색하고, 긴급한 것만 보거나, 열 안의 순서를 내 순서·기한순·우선순위순으로 정합니다.',
  columnsT: '열',
  columnsB: '백로그, 할 일, 진행 중, 검토, 완료입니다. 일이 진행되면 카드를 다른 열로 끌어 옮기고, 카드를 클릭하면 열립니다.',
  newT: '새 업무',
  newB: '설명, 파일, 기한, 담당자를 넣어 업무를 만듭니다. 업무 생성 권한이 있을 때만 이 버튼이 보입니다.',
  shareT: '내 보드 공유',
  shareB: '내 보드를 볼 수 있는 사람을 정합니다. 공유받은 사람은 자신의 보드 목록에서 열 수 있습니다.',
};
const vi = {
  boardsT: 'Bảng của ai',
  boardsB: 'My tasks là bảng của bạn. Bên cạnh là các bảng người khác chia sẻ cho bạn, còn Shared with me liệt kê các việc được chia sẻ riêng lẻ.',
  viewsT: 'Ba kiểu xem',
  viewsB: 'Board hiện các cột, Timeline xếp việc theo ngày, còn My day tóm tắt những gì bạn đã làm hôm nay.',
  searchT: 'Tìm kiếm và lọc',
  searchB: 'Tìm việc trên bảng này, chỉ hiện việc gấp, và chọn cách sắp xếp trong mỗi cột: theo thứ tự của bạn, theo hạn hoặc theo mức ưu tiên.',
  columnsT: 'Các cột',
  columnsB: 'Backlog, To do, In progress, Review và Done. Kéo thẻ sang cột khác khi việc tiến triển; bấm vào thẻ để mở.',
  newT: 'Việc mới',
  newB: 'Tạo một việc kèm mô tả, tệp, hạn và những người liên quan. Nút này chỉ hiện khi bạn có quyền tạo việc.',
  shareT: 'Chia sẻ bảng của tôi',
  shareB: 'Chọn ai được xem bảng của bạn. Người được chia sẻ mở nó từ danh sách bảng của họ.',
};
const zh = {
  boardsT: '谁的看板',
  boardsB: '“我的任务”是你自己的看板。旁边是别人与你共享的看板,“与我共享”列出被单独共享给你的任务。',
  viewsT: '三种视图',
  viewsB: '看板按列显示,时间线按日期排布任务,“我的一天”汇总你今天做了什么。',
  searchT: '搜索与筛选',
  searchB: '搜索本看板上的任务,只看紧急任务,并选择每列的排序方式:自己的顺序、按截止日期或按优先级。',
  columnsT: '各列',
  columnsB: '待办池、待办、进行中、审核和完成。工作推进时把卡片拖到另一列,点击卡片即可打开。',
  newT: '新建任务',
  newB: '创建任务并填写描述、文件、截止日期和相关人员。只有你有创建任务的权限时才会显示这个按钮。',
  shareT: '共享我的看板',
  shareB: '选择谁可以查看你的看板。被共享的人可以在自己的看板列表中打开它。',
};
const dictionary = { ns: 'tourTasks', en, ko, vi, zh };
export default dictionary;
